import script from "./LeitnerAddWordFab.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeitnerAddWordFab.vue?vue&type=script&setup=true&lang=ts"

import "./LeitnerAddWordFab.vue?vue&type=style&index=0&id=76a8e092&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76a8e092"]])

export default __exports__